export const IS_MODAL = "IS_MODAL"
export const LEXICONS_IS_CONFIRMATION_MODAL = "LEXICONS_IS_CONFIRMATION_MODAL"
export const CLEAN_LEXICONS_CONTEXT = "CLEAN_LEXICONS_CONTEXT"